import React, { useContext  } from 'react';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import {
  Box,
} from '@mui/material';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import Button from '@mui/material/Button';
import { ArrowLeft } from '@mui/icons-material';
import { HistoryContext } from '../Context/HistoryContext';
import { useUserContext } from '../Context/UserContext';
import {
  CircularProgress
} from '@mui/material';

export default function Header() {
  const navigate = useNavigate();
  const { history, setHistory } = useContext(HistoryContext);
  const { totalPoints, loading } = useUserContext();

  const handleBack = () => {
    if (history.length > 1) {
      const newHistory = [...history];
      newHistory.pop(); // Remove current path
      const previousPath = newHistory[newHistory.length - 1];
      newHistory.pop(); // Remove previous path because it will be added again
      setHistory(newHistory);
      navigate(previousPath);
    }
  };
  
  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: 'center',
        mx: 3,
        pb: 1,
        mt: { xs: 12, md: 0 },
      }}
    >
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <Stack
          direction="row"
          sx={{
            width: '100%',
            justifyContent: 'space-between',
          }}
        >

          <Button variant="text" color='primary' disabled={history.length <= 1} onClick={handleBack} startIcon={<ArrowLeft />}>
            <b>Back</b>
          </Button>
          
          {(loading) ? (
            <center>
              <CircularProgress style={{ color: '#3D9BE9' }} />
            </center>
          ):(
            <Box 
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f0f4f0',
                borderRadius: '8px',
                padding: '8px 16px',
                color: '#66bb6a',
                fontWeight: 'bold',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              }}>
              <ElectricBoltIcon sx={{ color: '#66bb6a', marginRight: '8px' }} />
              {totalPoints} {totalPoints === 1 ? "point" : "points"}
            </Box>
          )}
          
        </Stack>
      </Box>
    </Stack>
  );
}
